import React, { useState, useEffect } from 'react';
import { useAuthContext } from 'jsx/auth/AuthProviderV2';
import { useLocale } from 'jsx/locale/LanguageProviderV2';
import { navigationApi } from 'utils/api/shared';
import UM from 'jsx/layout/UserMenuV2';
import UMItem from 'jsx/layout/UserMenu/UserMenuItemV2';
import { sortBy } from 'utils/sorting';

export const UserMenu = ({ open, toggleMenu }) => {
  const [products, setProducts] = useState([]);
  const { lang, t, setLanguage } = useLocale();
  const { logOut, isAuthenticated } = useAuthContext();

  function toggleLang() {
    const newLang = lang === 'is' ? 'en' : 'is';
    setLanguage(newLang);
  }

  useEffect(() => {
    if (!isAuthenticated) return;
    navigationApi.getSettingsUrls().then(res => {
      if (res.error) return;
      setProducts(sortBy(res, 'levelOrder'));
    });
  }, [isAuthenticated]);

  return (
    <UM open={open} toggleOpen={toggleMenu}>
      {products.map(product => (
        <UMItem
          iconCls={product.icon}
          link={product.url}
          key={product.navigationID}
          label={t(`Navigator.DisplayText.${product.navigationID}`) || product.displayText}
        />
      ))}
      <UMItem
        iconCls="icon-earth"
        label={lang === 'is' ? 'English' : 'Íslenska'}
        onClick={toggleLang}
      />
      <UMItem iconCls="icon-exit" label={t('userMenu_logout')} onClick={logOut} />
    </UM>
  );
};
